import React from 'react';
import { CheckCircle, AlertTriangle } from 'lucide-react';

function TimelineStep({ label, active, completed, last }) {
    return (
        <div className="flex items-center gap-0 flex-1">
            <div className="flex flex-col items-center">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all ${
                    completed ? 'bg-green-500 text-white' :
                    active ? 'bg-gradient-to-r from-[#681793] to-[#FF914D] text-white ring-4 ring-[#681793]/20' :
                    'bg-muted text-muted-foreground'
                }`}>
                    {completed ? <CheckCircle className="w-4 h-4" /> : null}
                </div>
                <span className={`text-[10px] mt-1 text-center leading-tight max-w-[60px] ${
                    active || completed ? 'text-foreground font-medium' : 'text-muted-foreground'
                }`}>{label}</span>
            </div>
            {!last && (
                <div className={`h-0.5 flex-1 mx-1 mt-[-14px] ${completed ? 'bg-green-500' : 'bg-muted'}`} />
            )}
        </div>
    );
}

const STEPS = [
    { key: 'created', label: 'Créé' },
    { key: 'signed', label: 'Signé' },
    { key: 'active', label: 'En vente' },
    { key: 'offer', label: 'Offre' },
    { key: 'compromis', label: 'Compromis' },
    { key: 'sold', label: 'Vendu' },
];

const STATUS_ORDER = { brouillon: 0, a_signer: 0, en_signature: 1, actif: 2, offre: 3, compromis: 4, vendu: 5, denonce: -1, expire: -1 };

export default function SellerTimeline({ status }) {
    const currentIdx = STATUS_ORDER[status] ?? 0;

    if (status === 'denonce' || status === 'expire') {
        return (
            <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-red-500/10 border border-red-500/20">
                <AlertTriangle className="w-4 h-4 text-red-400" />
                <span className="text-sm text-red-400 font-medium">
                    {status === 'denonce' ? 'Mandat dénoncé' : 'Mandat expiré'}
                </span>
            </div>
        );
    }

    return (
        <div className="flex items-start">
            {STEPS.map((step, idx) => (
                <TimelineStep
                    key={step.key}
                    label={step.label}
                    completed={idx < currentIdx}
                    active={idx === currentIdx}
                    last={idx === STEPS.length - 1}
                />
            ))}
        </div>
    );
}
